import React, { Component } from 'react';
import * as $ from 'jquery';
import PromocodeDialog from './PromocodeDialog.js';
import { translate } from 'react-i18next';

class Summit extends Component {

    handlePromocodeClick = () => {
        $('#btnPromocode').click();
    }

    renderPromocodeDialog = () => {
        return (
            <PromocodeDialog
                handleClearPromocode={this.props.handleClearPromocode}
                handlePromocodeChange={this.props.handlePromocodeChange}
                handlePromocodeSubmit={this.handlePromocodeSubmit}
                promocode={this.props.promocode}
                promocodeError={this.props.promocodeError} />
        );
    }


    render() {
        const { t } = this.props;
        return (
            <div className="jumbotron panel-benefits panel-summit">
                <div className="row">
                    <div className="col-md-12">
                        <form method="post" onSubmit={this.props.handleSummit}>
                            <fieldset>
                                <div className="form-group">
                                    <h2 className="form-group-title">Datos Personales</h2>
                                </div>
                                <div className="form-group">
                                    <h4 className="form-group-subtitle">Acceso general</h4>
                                </div>
                                <div className="form-group  col-md-12 col-sm-12">
                                    <input
                                        className="form-control"
                                        maxLength="16"
                                        onChange={this.props.handleChangePromocode}
                                        type="text"
                                        placeholder={"INGRESAR PROMOCODE"}
                                        value={this.props.promoCode} />
                                </div>
                                <div className="form-group  col-md-6 col-sm-12">
                                    <input
                                        required
                                        className="form-control"
                                        id="name_summit"
                                        value={this.props.nombre}
                                        placeholder={"INGRESAR NOMBRE"}
                                        type="text"
                                        onChange={this.props.handleChanegeName} />
                                </div>
                                <div className="form-group  col-md-6 col-sm-12">
                                    <input
                                        required
                                        className="form-control"
                                        id="name_summit"
                                        value={this.props.lastname}
                                        placeholder={"INGRESAR APELLIDOS"}
                                        type="text"
                                        onChange={this.props.handleChanegeLastName} />
                                </div>
                                <div className="form-group col-sm-12">
                                    <input
                                        required
                                        className={this.props.is_errorcheck ? "form-control form-control-negative" : "form-control"}
                                        id="email_summit"
                                        value={this.props.correo}
                                        placeholder={"INGRESAR CORREO"}
                                        type="text"
                                        onChange={this.props.handleChanegeCorreo} />
                                    {this.props.is_errorcheck
                                        ? <p>Detección de registros duplicados</p>
                                        : null}
                                </div>
                                <div className="form-group  col-md-5 col-sm-12">
                                    <input
                                        required
                                        className="form-control"
                                        id="phone_summit"
                                        value={this.props.celular}
                                        placeholder={"INGRESAR TELÉFONO"}
                                        type="number"
                                        onChange={this.props.handleChanegeCelular} />
                                </div>
                                <div className="form-group  col-md-3 col-sm-12">
                                    <input
                                        required
                                        className="form-control"
                                        id="year_summit"
                                        value={this.props.edad}
                                        placeholder={"EDAD"}
                                        type="number"
                                        onChange={this.props.handleChanegeEdad} />
                                </div>
                                <div className="form-group  col-md-4 col-sm-12">
                                    <select
                                        required
                                        className="form-control"
                                        id="geneder_summit"
                                        onChange={this.props.handleChanegeGenero}
                                        value={this.props.genero}>
                                        <option value="">GÉNERO</option>
                                        <option value="2">Femenino</option>
                                        <option value="1">Masculino</option>
                                    </select>
                                </div>
                                <div className="form-group  col-sm-4">
                                    <select
                                        required
                                        className="form-control"
                                        id="business_summit"
                                        onChange={this.props.handleEstadosChange}
                                        value={this.props.estados_id}
                                        style={{ "fontSize": " 12px" }}>
                                        <option value="">SELECCIONE UN ESTADO</option>
                                        {this.props.estados ? (
                                            this.props.estados.map((estado, index) =>
                                                <option key={index} value={estado.id}>{estado.name}</option>
                                            )
                                        ) : null}
                                    </select>
                                </div>

                                <div className="form-group col-sm-4">
                                    <select
                                        required
                                        disabled={!this.props.estados_id ? true : false}
                                        className="form-control"
                                        id="business_summit"
                                        onChange={this.props.handleCuidadesListChange}
                                        value={this.props.ciudad_id}
                                        style={!this.props.estados_id ? { "fontSize": "12px", "color": "#999" } : { "fontSize": "12px" }}>
                                        <option value="">SELECCIONE UNA CIUDAD</option>
                                        {this.props.ciudades ? (
                                            this.props.ciudades.map((ciudades, index) =>
                                                <option key={index} value={ciudades.id}>{ciudades.name}</option>
                                            )
                                        ) : null}
                                    </select>
                                </div>
                                <div className="form-group col-md-4">
                                    <select
                                        required
                                        className="form-control"
                                        id="info_summit"
                                        onChange={this.props.handleChangeEvent}
                                        value={this.props.como_se_entero}>
                                        <option value="">¿CÓMO SE ENTERÓ?</option>
                                        <option value="1">Soy socio IOS</option>
                                        <option value="2">Revista</option>
                                        <option value="3">Web Digital</option>
                                        <option value="4">Referencia</option>
                                        <option value="5">Redes Sociales</option>
                                    </select>
                                </div>
                                {this.props.como_se_entero === "5" ? (
                                    <div className="form-group col-sm-12">
                                        <label htmlFor="center">¿CUAL?</label>
                                        <select
                                            required
                                            className="form-control"
                                            id="red_social" name="red_social"
                                            onChange={this.props.handleChangeSocial}
                                            value={this.props.redSocial}>
                                            <option value="">Selecione una opción</option>
                                            <option value="1">Facebook</option>
                                            <option value="2">Instagram</option>
                                            <option value="3">Twitter</option>
                                            <option value="4">Linkedin</option>
                                        </select>
                                    </div>
                                ) : null}
                                {this.props.como_se_entero === "4" ? (
                                    <div className="form-group-textarea col-sm-12" >
                                        <label htmlFor="description">
                                            DESCRIBIR REFENCIA
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="comentRefence"
                                            name="como_se_entero_descrp"
                                            placeholder="Referido"
                                            onChange={this.props.handleChanegeevento_descrp}
                                            value={this.props.como_se_entero_descrp}>
                                        </textarea>
                                    </div>
                                ) : null}
                                <div className="form-group">
                                    <h2 className="form-group-title">Datos de la empresa</h2>
                                </div>
                                <div className="form-group  col-md-6 col-sm-12">
                                    <input
                                        required
                                        className="form-control"
                                        id="empresa_summit"
                                        value={this.props.empresa}
                                        placeholder={"INGRESAR NOMBRE DE EMPRESA"}
                                        type="text"
                                        onChange={this.props.handleChanegeEmpresa} />
                                </div>
                                <div className="form-group col-md-3 col-sm-12">
                                    <select
                                        required
                                        className="form-control"
                                        id="tp_empresa_summit"
                                        onChange={this.props.handleChanegetp_empresa}
                                        value={this.props.tipo_empresa}>
                                        <option value=""># EMPLEADOS</option>
                                        <option value="1">1</option>
                                        <option value="2">2 - 15</option>
                                        <option value="3">15 - 50</option>
                                        <option value="4">50 - 100</option>
                                        <option value="5">100 - 500</option>
                                        <option value="6">500 o más</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-3 col-sm-12">
                                    {/* <label htmlFor="center">
                                        PUESTO
                                    </label> */}
                                    <select
                                        required
                                        className="form-control"
                                        id="puesto_summit"
                                        onChange={this.props.handleChangePuesto}
                                        value={this.props.puesto}>
                                        <option value="">PUESTO</option>
                                        <option value="1">CEO/Dueño</option>
                                        <option value="2">Director/Gerente</option>
                                        <option value="3">Ejecutivo/Colaborador</option>
                                        <option value="4">Startup</option>
                                        <option value="5">Estudiante</option>
                                        <option value="6">Prensa</option>
                                        <option value="7">Otro</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-6 col-sm-12">
                                    <select
                                        required
                                        className="form-control"
                                        id="business_summit"
                                        onChange={this.props.handlebusinesChange}
                                        value={this.props.busines}>
                                        <option value="">GIRO DE LA EMPRESA</option>
                                        {this.props.business ? (
                                            this.props.business.map((giro, index) =>
                                                <option key={index} value={giro.id}>{giro.name}</option>
                                            )
                                        ) : null}
                                    </select>
                                </div>
                                <div className="form-group col-md-6">
                                    <div className="form-group-button">
                                        <button
                                            disabled={this.props.ispayfree}
                                            className="btn btn-primary btn-resvations btn-search-benefits btn-summit"
                                            type="submit">
                                            CONTINUAR
                                        </button>
                                    </div>
                                </div>
                            </fieldset >
                        </form >
                    </div>
                    {this.renderPromocodeDialog()}
                </div >
            </div >
        )
    }
}

export default translate('common')(Summit);


// WEBPACK FOOTER //
// ./src/guest/summit/Summit.js